// Animated VIP / Elite nameplate badge shown next to a username.
const NAMEPLATE_STYLES = {
  vip_gold: { text: "VIP", className: "np-gold" },
  vip_pulse: { text: "👑 VIP", className: "np-pulse" },
  elite_rainbow: { text: "⭐ ELITE", className: "np-rainbow" },
  elite_diamond: { text: "💎 ELITE", className: "np-diamond" },
};

export const Nameplate = ({ nameplate, className = "" }) => {
  const s = NAMEPLATE_STYLES[nameplate];
  if (!s) return null;
  return <span className={`nameplate-badge ${s.className} ${className}`} data-testid={`nameplate-${nameplate}`}>{s.text}</span>;
};

export default Nameplate;
